import React, {lazy} from 'react';
// import {Bridge} from "../../bridge/bridge";
import {Switch} from "react-router-dom";
import PrivateRoute from "../PrivateRoute/PrivateRoute";

const webViewRoute = () => {
  // const bridge = Bridge.init();
  const webViewComponent = lazy(() => import("../../components/WebviewProxy/WebviewProxy"));
  return (
    <Switch>
      {/*<PrivateRoute exact path={'/app/:type'} component={webViewComponent}*/}
      {/*              bridge={bridge}/>*/}
      <PrivateRoute exact path={'/app/:type'} component={webViewComponent}/>
    </Switch>
  );
}

export default webViewRoute;
